import { ServerAdapterFactory } from './ServerAdapterFactory.js';
import { Constants as C, methods as M } from './methods.js';
const CreateMonitoredDataItems = '/Methods/CreateMonitoredDataItems';
const PublishData = '/Methods/PublishData';
/**
 * 
 * */
export class trendWorker {

    constructor(id, type) {
        this.ServerAdapter = ServerAdapterFactory.GetAdapterInstance(id, type);
        this.ServerAdapter.reSubscribe = this.reSubscribe.bind(this);
        this.location = window._globalParams.location;
        this.isBusy = false;
        this.started = false;
    }

    async CreateDataSubscription() {
        const pack = {
            requestedPublishingInterval: 100,
            requestedLifetimeInterval: 60000,
            maxNotificationsPerPublish: 0,
            maxSize: 1000,
            sourceId: this.ServerAdapter.id
        };
        const options = {
            method: M.CreateDataSubscription,
            methodType: C.single,
            pack
        }
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, data => {
                this.ServerAdapter.subscriptionId = data.subscriptionId;
                resolve(data);
            });
        });
    }

    async CreateMonitoredDataItems(items, subId) {
        if (!items) return;
        if (items.length > 0) {
            let ssid = subId || this.ServerAdapter.subscriptionId;
            this.SubPack = {
                subscriptionId: ssid,
                items
            };
            this.storeItems(items);
            const options = {
                method: M.CreateMonitoredDataItems,
                methodType: C.single,
                pack: this.SubPack,
            };
            return await new Promise(resolve => {
                this.ServerAdapter.sendRequest(options,
                    data => resolve(data));
            });
        }
    }

    storeItems(items) {
        items.forEach((item) => {
            if (!item.key) {
                item.key = item.itemId;
                if (item.path)
                    item.key += "." + item.path;
            }
        });

        if (this.itemsContainer === undefined) {
            this.itemsContainer = [];
            this.itemsContainer.push(...items);
        } else {
            let filtered = this.itemsContainer.filter(elem => !items.find(item => elem.key === item.key))
            this.itemsContainer = filtered.concat(items);
        }
    }


    StartWatch() {
        if (this.started)
            return;
        this.started = true;

        let options = {
            methodType: C.intervalStart,
            method: M.PublishData,
            interval: window._globalParams.UpdateInterval,
            updateTrend: true
        };
        this.ServerAdapter.sendRequest(options, answer => {
            if (answer.recs) {
                let element;
                for (let index = 0; index < answer.recs.length; index++) {
                    element = answer.recs[index];
                    this.LinkUp(element);
                }
                element = null;
            } else {
                this.UpdateTime(answer.serverTime);
            }
            answer = null;
        });
    }

    StopWatch() {
        if (!this.started) return;
        this.started = false;
        const options = {
            methodType: C.intervalStop,
            method: M.PublishData
        };
        this.ServerAdapter.sendRequest(options);
    }

    async reSubscribe() {
        this.isBusy = true;
        this.StopWatch();
        return await this.CreateDataSubscription()
            .then(response => this.CreateMonitoredDataItems(this.itemsContainer, response.subscriptionId)
                .then((data) => {
                    if (data?.code === 0 && this.ItemSubscribed) {
                        for (let index = 0; index < data.items.length && index < this.itemsContainer.length; index++) {
                            this.ItemSubscribed(this.itemsContainer[index], data.items[index].monitoredItemId);
                        }
                    }

                    this.onRestore();
                }));
    }

    onRestore() {
        this.StartWatch();
    }

    async getAsyncArchiveData(startTime, endTime, resampleInterval, items) {
        const subscriptionId = this.ServerAdapter.subscriptionId;
        const parameters = {
            startTime,
            endTime,
            resampleInterval,
            returnBounds: true,
            subscriptionId,
        };
        const pack = {
            parameters,
            data: items
        };
        const options = {
            methodType: C.single,
            method: M.HistoryReadRawAsync,
            pack
        };
        return await new Promise((resolve) => {
            this.ServerAdapter.sendRequest(options, data => {
                this.publishHistoryData(data, []).then(storage => resolve(storage)).catch(() => {});
            });
        });
    }
    async publishHistoryData(item, storage) {
        let options = {
            methodType: C.single,
            method: M.PublishHistoryData,
            pack: item
        }
        return await new Promise((resolve, reject) => {
            this.ServerAdapter.sendRequest(options, data => {
                if (data.code) {
                    switch (data.code) {
                        case 0x80320000: //запрос в обработке, но не готов
                            setTimeout(() => {
                                resolve(this.publishHistoryData(item, storage));
                            }, 100)
                            break;
                        case 0x802A0000: //запрос был удален
                            reject()
                            break;
                        case 0x00A60000: //будут еще пакеты с данными
                            storage.push(data.data);
                            resolve(this.publishHistoryData(item, storage));
                            break;
                        case 0x80840000:
                        case 0x804A0000: //нет запрашиваемого subscriptionId
                        default:
                            resolve(storage);
                    }
                } else {
                    storage.push(data.data);
                    resolve(storage);
                }
            });
        });
    }

    async getArchiveItems(item) {
        const { taskId, itemId, path } = item;
        const items = [{ taskId, itemId, path }];
        if (typeof item.type !== 'undefined') items['type'] = item.type;
        const pack = {
            items
        };
        const options = {
            methodType: C.single,
            method: M.GetArchiveItems,
            pack
        };
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, data => {
                resolve({ ...data.items?.[0], ...options.pack.items?.[0] });
            });
        });
    }

    async HistoryReadRaw(startTime, endTime, resampleInterval, item) {
        const pack = {
            parameters: {
                startTime,
                endTime,
                returnBounds: true,
                returnFirstLastValue: (endTime == 0 && startTime == 0),
                resampleInterval: resampleInterval
            },
            data: [item]
        };
        const options = {
            methodType: C.single,
            method: M.HistoryReadRaw,
            pack
        };
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, answer => {
                resolve(answer.data);
            });
        });
    }

    async DeleteMonitoredDataItems(monitoredItemId) {
        if (!monitoredItemId) return;
        const pack = {
            items: [monitoredItemId],
            subscriptionId: this.ServerAdapter.subscriptionId,
        };
        let options = {
            methodType: C.single,
            method: M.DeleteMonitoredDataItems,
            pack
        };
        return await new Promise(resolve => {
            this.ServerAdapter.sendRequest(options, data => {
                resolve(data);
            });
        });
    }
}
